/**
 * Utilities for detecting and processing video embed HTML from the CMS.
 * Supports both legacy iframe embeds (video.ramboll.com / TwentyThree)
 * and Wistia web-component embeds.
 */

export const isWistiaEmbed = (html: string | undefined | null): boolean => {
  if (!html) return false;
  return html.includes('wistia-player') || html.includes('fast.wistia.com');
};

export const getWistiaMediaId = (html: string | undefined | null): string | null => {
  if (!html) return null;

  const attrMatch = html.match(/media-id=["']([a-zA-Z0-9]+)["']/i);
  if (attrMatch) return attrMatch[1];

  const scriptMatch = html.match(/fast\.wistia\.com\/embed\/([a-zA-Z0-9]+)\.js/);
  if (scriptMatch) return scriptMatch[1];

  return null;
};

export const getWistiaThumbnail = (mediaId: string): string =>
  `https://fast.wistia.com/embed/medias/${encodeURIComponent(mediaId)}/swatch?image_crop_resized=1280x720`;

export const getWistiaAspect = (html: string | undefined | null): string => {
  if (!html) return '1.7777777777777777';
  const match = html.match(/aspect=["']([0-9.]+)["']/i);
  return match ? match[1] : '1.7777777777777777';
};
